/*
  * Palo Alto Theme
  *
  * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
  * Javascript in this fill will make it easier to update Palo Alto. In order
  * to use this file you will need to open layout/theme.liquid and uncomment
  * the custom.js script import line near the bottom of the file.
*/
console.log("adad");
// Function to open the popup



 document.addEventListener("DOMContentLoaded", (event) => {
   
    document.body.addEventListener("theme:variant:change",(evt)=> {
      if(document.querySelectorAll("body#gift-card").length > 0){
        console.log(evt,evt.detail, "theme:variant:change");
        const addtotext = theme.strings.add_to_cart;
        const variant = evt.detail.variant;
  
        const price = (variant.price/100).toFixed(2);
        document.querySelector(".product-single__details .product__submit__item .product__submit__add span").textContent=`${addtotext} - $${price}`;
      }
      
      
    });
  });

/* ---------- Product gallery: dots / counter instead of thumbnails ---------- */
(function () {
  var DOT_LIMIT = 8;   // 8 or fewer images -> dots; more -> "3 / 11" counter

  var css =
    '.product-single__thumbnails{display:none !important;}' +
    '@media (max-width:767px){.product-single__media-slider .product-single__media-slide{width:88%;}}' +
    '.pdd-gallery-nav{display:flex;align-items:center;justify-content:center;gap:8px;padding:12px 0 2px;}' +
    '.pdd-gallery-nav__dot{appearance:none;-webkit-appearance:none;width:8px;height:8px;padding:0;border-radius:50%;' +
      'border:1px solid var(--COLOR-TEXT,#0b0b0b);background:transparent;opacity:.35;cursor:pointer;' +
      'transition:opacity .2s,background .2s;}' +
    '.pdd-gallery-nav__dot.is-active{background:var(--COLOR-TEXT,#0b0b0b);opacity:1;}' +
    '.pdd-gallery-nav__dot:hover{opacity:.7;}' +
    '.pdd-gallery-nav__dot.is-active:hover{opacity:1;}' +
    '.pdd-gallery-nav__dot:focus-visible{outline:2px solid var(--COLOR-ACCENT,#ae927d);outline-offset:3px;}' +
    '.pdd-gallery-nav__count{font-family:var(--FONT-STACK-BODY);font-size:.85rem;letter-spacing:.05em;' +
      'color:var(--COLOR-TEXT);font-variant-numeric:tabular-nums;}';

  var style = document.createElement('style');
  style.id = 'pdd-gallery-style';
  style.textContent = css;
  document.head.appendChild(style);

  var tries = 0;

  function init() {
    var slider  = document.querySelector('.product-single__media-slider');
    var gallery = document.querySelector('.product-single__gallery');
    if (!slider || !gallery) return;                       // not a product page
    if (document.querySelector('.pdd-gallery-nav')) return; // already built

    var slides  = Array.prototype.slice.call(slider.querySelectorAll('.product-single__media-slide'));
    var nextBtn = slider.querySelector('.flickity-prev-next-button.next');
    var prevBtn = slider.querySelector('.flickity-prev-next-button.previous');

    // the theme builds the slider after load - wait for it
    if ((!nextBtn || !prevBtn) && tries++ < 25) { setTimeout(init, 120); return; }
    if (slides.length < 2 || !nextBtn || !prevBtn) return;

    var nav = document.createElement('div');
    nav.className = 'pdd-gallery-nav';
    gallery.appendChild(nav);

    var dots = [], counter = null;

    function current() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-selected')) return i;
      }
      return 0;
    }

    function goTo(target) {
      var delta = target - current();
      if (delta === 0) return;
      var btn = delta > 0 ? nextBtn : prevBtn;
      var was = btn.style.display;
      btn.style.display = 'block';          // must be visible for the click to register
      for (var i = 0; i < Math.abs(delta); i++) btn.click();
      btn.style.display = was;
    }

    if (slides.length <= DOT_LIMIT) {
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdd-gallery-nav__dot';
        b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + slides.length);
        b.addEventListener('click', function () { goTo(i); });
        nav.appendChild(b);
        dots.push(b);
      });
    } else {
      counter = document.createElement('span');
      counter.className = 'pdd-gallery-nav__count';
      counter.setAttribute('role', 'status');
      nav.appendChild(counter);
    }

    function sync() {
      var i = current();
      if (counter) { counter.textContent = (i + 1) + ' / ' + slides.length; return; }
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    var mo = new MutationObserver(sync);
    slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    
    sync();
    window.dispatchEvent(new Event('resize'));   // let Flickity re-measure the narrower slides
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else {
    setTimeout(init, 0);
  }
})();

/* ---------- Accessible names for icon-only controls ---------- */
(function () {
  var LABELS = [
    ['.pswp__button--close',        'Close image viewer'],
    ['.pswp__button--share',        'Share'],
    ['.pswp__button--fs',           'Toggle fullscreen'],
    ['.pswp__button--zoom',         'Zoom in or out'],
    ['.pswp__button--arrow--left',  'Previous image'],
    ['.pswp__button--arrow--right', 'Next image'],
    ['.search-popdown__close',      'Close search'],
    ['.drawer__logo',               'PerfectDD home'],
    ['.social-sharing-icon.instagram', 'PerfectDD on Instagram'],
    ['.social-sharing-icon.tiktok',    'PerfectDD on TikTok'],
    ['.social-sharing-icon.facebook',  'PerfectDD on Facebook'],
    ['.social-sharing-icon.pinterest', 'PerfectDD on Pinterest'],
    ['.social-sharing-icon.youtube',   'PerfectDD on YouTube']
  ];

  function label() {
    LABELS.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (el) {
        var named = (el.textContent || '').trim() ||
                    el.getAttribute('aria-label') ||
                    el.getAttribute('aria-labelledby');
        if (!named) el.setAttribute('aria-label', pair[1]);
      });
    });
  }

  function run() {
    label();
    // the lightbox and search panel are built on demand - catch them when they appear
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(label, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* ---------- Remove empty links around footer badge images ---------- */
(function () {
  function unwrap() {
    document.querySelectorAll('.footer-text-image-with-link a').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href === null || href.trim() === '' || href === '#') {
        while (a.firstChild) a.parentNode.insertBefore(a.firstChild, a);
        a.remove();
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', unwrap);
  } else {
    unwrap();
  }
})();

/* ---------- Alt text for menu + footer images the theme renders without it ---------- */
(function () {
  // match on part of the filename, so the ?v= version and re-uploads don't break it
  var ALT_MAP = [
    ['Krista_Tulip_Tee_in_Cappuccino',       'Krista Tulip Tee in cappuccino'],
    ['Charisse_in_Black',                    'Charisse sweatshirt in black'],
    ['Classic_Button_Down_as_seen_on_Oprah', 'The Classic Button Down, featured by Oprah Daily'],
    ['Katie_Short_Sleeve_Zip_Up',            'Katie short sleeve zip hoodie'],
    ['Gift_Card',                             'PerfectDD gift card'],
    ['menu_comparison',                      'PerfectDD fit comparison'],
    ['Business_Certification_Badges',        'Certified Women-Owned Business, Made in USA']
  ];

  function applyAlt() {
    Array.prototype.forEach.call(document.images, function (img) {
      if (img.hasAttribute('alt')) return;
      var src = img.getAttribute('src') || img.currentSrc || '';
      for (var i = 0; i < ALT_MAP.length; i++) {
        if (src.indexOf(ALT_MAP[i][0]) > -1) { img.alt = ALT_MAP[i][1]; return; }
      }
    });
  }

  function run() {
    applyAlt();
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(applyAlt, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* ---------- Size Guide: inline link on the SIZE line + modal ---------- */
(function () {
  function init() {
    var legend = document.querySelector('.main-size-selector-div .radio__legend');
    if (!legend || legend.querySelector('.pdd-sizeguide-btn')) return;

    var src   = document.getElementById('pddChartSource');
    var table = src && src.querySelector('table');

    var accTrigger = document.querySelector('.product__accordion__title[aria-controls*="size-guide"], .product__accordion__title[aria-controls*="find-your-size"]');
    var accWrap = accTrigger && accTrigger.closest('.product__accordion');
    var accBody = accTrigger && document.getElementById(accTrigger.getAttribute('aria-controls'));
    var content = table || (accBody && accBody.querySelector('table, img'));
    if (!content) return;

    var css =
      '.main-size-selector-div .radio__legend{display:flex;align-items:baseline;justify-content:space-between;gap:12px;width:100%;}' +
      '.pdd-sizeguide-btn{appearance:none;border:0;cursor:pointer;' +
        'font-family:var(--FONT-STACK-HEADING);font-size:calc(1.1rem * var(--adjust-label));font-weight:700;' +
        'letter-spacing:.05em;text-transform:uppercase;' +
        'background-color:#FBCD0A;color:#0b0b0b;padding:2px 8px;' +
        'text-decoration:underline;text-underline-offset:3px;}' +
      '.pdd-sizeguide-btn:hover{background-color:#e6bb09;}' +
      '.pdd-sizeguide-btn:focus-visible{outline:2px solid var(--COLOR-ACCENT,#ae927d);outline-offset:3px;}' +
      '@media (max-width:767px){.pdd-sizeguide-btn{font-size:calc(1rem * var(--adjust-label));}}' +
      '.pdd-modal{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;padding:20px;}' +
      '.pdd-modal.is-open{display:flex;}' +
      '.pdd-modal__scrim{position:absolute;inset:0;background:rgba(11,11,11,.55);}' +
      '.pdd-modal__panel{position:relative;background:#fff;max-width:640px;width:100%;max-height:86vh;overflow:auto;padding:22px 22px 26px;}' +
      '.pdd-modal__title{font-family:var(--FONT-STACK-HEADING);font-size:1.15rem;font-weight:700;margin:0 40px 14px 0;}' +
      '.pdd-modal__close{position:absolute;top:12px;right:12px;background:none;border:0;font-size:1.4rem;line-height:1;cursor:pointer;padding:6px;}' +
      '.pdd-modal table{width:100%;border-collapse:collapse;font-family:var(--FONT-STACK-BODY);font-size:.85rem;}' +
      '.pdd-modal th,.pdd-modal td{border:1px solid var(--COLOR-BORDER,#ddd4cb);padding:7px 5px;text-align:center;white-space:nowrap;}' +
      '.pdd-modal thead th,.pdd-modal tbody th{background:#f3f3f3;font-weight:700;}' +
      '.pdd-modal tbody tr:nth-child(even) td{background:#fafafa;}' +
      '.pdd-modal img{max-width:100%;height:auto;}';
    var style = document.createElement('style');
    style.id = 'pdd-sizeguide-style';
    style.textContent = css;
    document.head.appendChild(style);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pdd-sizeguide-btn';
    btn.textContent = 'Size Guide';
    btn.setAttribute('aria-haspopup', 'dialog');
    legend.appendChild(btn);

    var modal = document.createElement('div');
    modal.className = 'pdd-modal';
    modal.innerHTML =
      '<div class="pdd-modal__scrim" data-close></div>' +
      '<div class="pdd-modal__panel" role="dialog" aria-modal="true" aria-labelledby="pddSizeModalTitle" tabindex="-1">' +
        '<button type="button" class="pdd-modal__close" data-close aria-label="Close size guide">&times;</button>' +
        '<h2 class="pdd-modal__title" id="pddSizeModalTitle">Size Guide</h2>' +
        '<div class="pdd-modal__body"></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelector('.pdd-modal__body').appendChild(content.cloneNode(true));

    if (accWrap) accWrap.style.display = 'none';

    var panel = modal.querySelector('.pdd-modal__panel');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      panel.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus) setTimeout(function () { lastFocus.focus(); }, 0);
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    btn.addEventListener('click', open);
    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close')) close();
    });
  }

  var tries = 0;
  function boot() {
    init();
    if (!document.querySelector('.pdd-sizeguide-btn') && tries++ < 25) {
      setTimeout(boot, 150);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();